module.exports = __webpack_public_path__ + "CrossStitchParlour.jpg?02847af189575468a2f25cf44c1fc526";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/CrossStitchParlour.jpg
// module id = 460
// module chunks = 0